import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import ModalCloseButton from '../../components/ModalCloseButton/ModalCloseButton';
import useTranslate from '../../hooks/useTranslate/useTranslate';

const InvalidSpecialCodeModal = ({ validationResult }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslate();
  const validationCheck = useRef(false);

  useEffect(() => {
    if (validationCheck.current) {
      return;
    }

    if (
      validationResult.toValidate !== undefined &&
      validationResult.validated
    ) {
      validationCheck.current = true;
    }

    if (
      validationResult.toValidate &&
      validationResult.validated &&
      !validationResult.valid
    ) {
      setOpen(true);
    }
  }, [
    validationResult.toValidate,
    validationResult.validated,
    validationResult.valid,
  ]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      style={{ maxWidth: '600px' }}
      centered
      external={
        <ModalCloseButton onClose={handleClose} className="modalCloseButton" />
      }
    >
      <ModalBody className="d-flex flex-column align-items-center">
        <div className="my-4" style={{ fontSize: '22px' }}>
          {t('Special code is not valid')}
        </div>
        <Button onClick={handleClose} className="button">
          OK
        </Button>
      </ModalBody>
    </Modal>
  );
};

InvalidSpecialCodeModal.propTypes = {
  validationResult: PropTypes.shape({
    toValidate: PropTypes.bool,
    validated: PropTypes.bool,
    type: PropTypes.string,
    valid: PropTypes.bool,
  }).isRequired,
};

export default InvalidSpecialCodeModal;
